import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class PartyRolesService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    indexPartyRoleTypesByCategory(partyRoleCategoryType: string): Observable<any> {
        return this.post<any>(EndPoints.partyRoles_indexPartyRoleTypesByCategory, false, '', {
            partyRoleCategoryType: partyRoleCategoryType
        });
    }
}
